import { getUserProfile } from "./getUserProfile"
import { updateUserProfile } from "./updateUserProfile"

export const updateUserScore = async(
    userId: string, 
    scoreIncrease: number, 
    streakCount?: number,
    crowdBeats?: number
  ): Promise<{
    success: boolean
    newScore: number
    rank?: number
    total?: number
  }> => {
    try {
      // Get current user profile
      const currentProfile = await getUserProfile(userId)
      
      if (!currentProfile) {
        console.error('User profile not found for score update')
        return { success: false, newScore: 0 }
      }

      // Calculate new totals
      const newScore = currentProfile.score + scoreIncrease
      const newStreak = streakCount !== undefined ? streakCount : currentProfile.streak
      const newCrowdBeats = crowdBeats !== undefined ? 
        currentProfile.crowd_beats + crowdBeats : currentProfile.crowd_beats

      // Update user profile
      const updatedProfile = await updateUserProfile(userId, {
        score: newScore,
        streak: newStreak,
        crowd_beats: newCrowdBeats
      })

      if (!updatedProfile) {
        return { success: false, newScore: currentProfile.score }
      }

      return {
        success: true,
        newScore
      }

    } catch (error) {
      console.error('Error updating user score:', error)
      return { success: false, newScore: 0 }
    }
  }